import { remainingWaitParts, timeTicker } from './relativeTime';

// The weekly quota resets every 7 dygn — the countdown copy must never
// open above that ("8 dagar") when the backend's target overshoots by
// seconds.
export const WEEKLY_UNLOCK_MAX_DAYS = 7;

// AB test 'one-match-per-week': the quota-banner copy shared verbatim
// by the matches page and the new-match sheet, driven by the summary's
// unlockMatchAvailableAt date (undefined = summary not loaded, null =
// unlock available now, date = cooldown running). Reads the shared
// minute ticker so an open tab counts down — at least a day left shows
// days, below that hours, both rounded up and never 0. `vm` supplies
// $t/$tc.
export function weeklyQuotaBannerText(vm, availableAt) {
  if (availableAt === undefined) return '';
  const wait = remainingWaitParts(availableAt, timeTicker.now, {
    maxDays: WEEKLY_UNLOCK_MAX_DAYS
  });
  if (!wait) {
    return vm.$t('matches_one_match_week_banner_available');
  }
  if (wait.unit === 'hour') {
    return vm.$tc('matches_one_match_week_banner_locked_hours', wait.value, {
      hours: wait.value
    });
  }
  return vm.$tc('matches_one_match_week_banner_locked', wait.value, {
    days: wait.value
  });
}
